import "./MenuHero.css";
import { Link } from "react-router-dom";
export default function MenuHero() {
  return (
    <section className="menu-hero">
      <div className="mh-overlay"></div>

      <div className="mh-content">
        <h1 className="mh-title">Menu List</h1>
        <p className="mh-subtitle">
          A taste of perfection in every dish – <span>fine dining</span>
        </p>

        <div className="mh-breadcrumb">
          <Link to="/">Home</Link>
          <span className="mh-arrow">›</span>
          <span>Menu List</span>
        </div>

        <div className="mh-scroll">
          <div className="scroll-icon"></div>
        </div>
      </div>
    </section>
  );
}
